import Sidebar from '../component/dashboard/Sidebar';
import { ToastContainer } from 'react-toastify';
import { Route, Routes } from 'react-router-dom';
import Itapplicants from '../component/dashboard/Itapplicants';
import Itdetails from '../component/dashboard/Itdetails';

const It = () => {
  return (
    <div>
      <ToastContainer closeButton={false} />
      <div className="layout_dashboard-sidebar" id="sidebar">
        <Sidebar />
      </div>
      <div className="layout_dashboard-content">
        <div className="dashboard-nav">
          <div className="dashboard-nav-user">
            <div>
              <h2>AD</h2>
            </div>
            <p>Admin</p>
          </div>
        </div>

        <Routes>
          <Route path="/" exact element={<Itapplicants />} />
          <Route path="itdetails" element={<Itdetails />} />
        </Routes>
      </div>
    </div>
  );
}

export default It
